import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** Move names called out over fighters (render/effects.ts). */
    callouts: boolean;
  }
}

defineSetting({
  key: 'callouts',
  default: true,
  order: 60,
  menu: { group: 'visual', label: 'ชื่อกระบวนท่าเหนือหัว' },
});
